// extracted by mini-css-extract-plugin
module.exports = {"modal":"MessageSentModal_modal__1UNsT","header":"MessageSentModal_header__2QDTh","body":"MessageSentModal_body__2ylVc","button":"MessageSentModal_button__3ftkM"};